import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const SentimentScoreTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>How positively a brand is represented in LLM responses</p>
            </BaseTooltip>
      );
};
